// extracted by mini-css-extract-plugin
module.exports = {"searchStartCard":"Card_searchStartCard__3WLX5"};